import { registerMutation, registerQuery, useMutation, useQuery } from 'data-fetching-client';
import noPortalApiClient from 'hub-http/clients/noPortalApiClient';
import Raven from 'raven-js';
const getUserProfile = userId => noPortalApiClient.get(`/api/academy-profile/v1/academy-profiles/user/${userId}`).catch(error => {
  if (error.status !== 404) {
    Raven.captureException(error);
  }
  throw error;
});
export const GET_USER_PROFILE = registerQuery({
  fetcher: ({
    userId
  }) => getUserProfile(userId),
  fieldName: 'user_profile',
  args: ['userId']
});
export const useGetUserProfile = userId => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_USER_PROFILE, {
    variables: {
      userId
    }
  });
  return {
    data,
    loading,
    error
  };
};
export const updateUserProfile = data => {
  return noPortalApiClient.put(`/api/academy-profile/v1/academy-profiles`, {
    data
  });
};
export const createUserProfile = data => {
  return noPortalApiClient.post(`/api/academy-profile/v1/academy-profiles`, {
    data
  });
};
export const UPDATE_USER_PROFILE_MUTATION = registerMutation({
  fieldName: 'updateUserProfile',
  args: ['displayName', 'userName', 'biography', 'companyName', 'jobTitle', 'public', 'twitterId', 'linkedinId', 'githubId', 'meetingsId', 'products', 'pronouns', 'industryCodeId'],
  fetcher: updateUserProfile
});
export const CREATE_USER_PROFILE_MUTATION = registerMutation({
  fieldName: 'createUserProfile',
  args: ['displayName', 'userName', 'biography', 'companyName', 'jobTitle', 'public', 'twitterId', 'linkedinId', 'githubId', 'meetingsId', 'products', 'pronouns', 'industryCodeId'],
  fetcher: createUserProfile
});
export const useUpdateUserProfile = () => useMutation(UPDATE_USER_PROFILE_MUTATION, {
  refetchQueries: [GET_USER_PROFILE]
});
export const useCreateUserProfile = () => useMutation(CREATE_USER_PROFILE_MUTATION, {
  refetchQueries: [GET_USER_PROFILE]
});